import { Box, Modal, Typography } from "@mui/material";
import React from "react";
type UserListFilterProp = {
  header: string;
  children: React.ReactNode;
  isVisible: boolean;
  handleClose: () => void;
};
const UserListFilter = ({
  children,
  header,
  handleClose,
  isVisible,
}: UserListFilterProp) => {
  // const style = {
  //   position: "absolute",
  //   top: "50%",
  //   left: "50%",
  //   transform: "translate(-50%, -50%)",
  //   bgcolor: "background.paper",
  //   border: "2px solid #000",
  //   boxShadow: 24,
  //   borderRadius: "16px",
  // };

  const style = {
    position: "absolute" as const,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    borderRadius: "16px",

    // ✅ Responsive width & height
    width: {
      xs: "90vw", // for mobile
      sm: "80vw", // small devices
      md: "auto", // medium and up
    },
    maxHeight: "90vh",
  };
  return (
    <>
      <Modal
        open={isVisible}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-description">
            <div className="card user-manage-model">
              <div className="card-header" id="webhooks">
                <h3 className="card-title">{header}</h3>
                <span
                  onClick={() => handleClose()}
                  style={{ cursor: "pointer" }}
                >
                  <i className="fa-solid fa-xmark"></i>
                </span>
              </div>
              <div className="card-body grid gap-10 d-flex">
                <div className="flex items-center flex-wrap lg:flex-nowrap user-list-filter-res">
                  {children}
                </div>
              </div>
            </div>
          </Typography>
        </Box>
      </Modal>
    </>
  );
};

export default UserListFilter;
